'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.executeActionSaga = executeActionSaga;

var _effects = require('redux-saga/effects');

var _metrixCommon = require('metrix-common');

var _selectReturns = require('../../selectors/workflow/selectReturns');

var _selectEntity = require('../../selectors/workflow/selectEntity');

var _selectAnonymous = require('../../selectors/workflow/selectAnonymous');

var _marked = /*#__PURE__*/regeneratorRuntime.mark(executeActionSaga);
// import { setStepVisibility } from './visibility';
// import { getStepValidation, setStepValidation } from './validation';
// import { reduceStep } from '../../actions/workflow/reduceStep';
// import { reduceControl } from '../../actions/workflow/reduceControl';
// import { reduceValid } from '../../actions/workflow/reduceValid';
// import { reduceStages } from '../../actions/workflow/reduceStages';
// import { reduceReturns } from '../../actions/workflow/reduceReturns';


function executeActionSaga(action) {
    var _action$payload, actionCode, guid, target, isNext, subfolderPrefix, response, returns, entity, anonymous, session, stepResponse, stepResult;

    return regeneratorRuntime.wrap(function executeActionSaga$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _action$payload = action.payload, actionCode = _action$payload.actionCode, guid = _action$payload.guid, target = _action$payload.target, isNext = _action$payload.isNext;
                    subfolderPrefix = process.env.REACT_APP_SUBFOLDER_NAME ? '/' + process.env.REACT_APP_SUBFOLDER_NAME : '';
                    _context.prev = 2;
                    response = void 0;
                    _context.next = 6;
                    return (0, _effects.put)((0, _metrixCommon.reduceLoading)(true));

                case 6:
                    if (!isNext) {
                        _context.next = 29;
                        break;
                    }

                    _context.next = 9;
                    return (0, _effects.select)((0, _selectReturns.selectReturns)());

                case 9:
                    returns = _context.sent;
                    _context.next = 12;
                    return (0, _effects.select)((0, _selectEntity.selectEntity)());

                case 12:
                    entity = _context.sent;
                    _context.next = 15;
                    return (0, _effects.select)((0, _selectAnonymous.selectAnonymous)());

                case 15:
                    anonymous = _context.sent;
                    _context.next = 18;
                    return (0, _metrixCommon.getSessionSaga)();

                case 18:
                    session = _context.sent;
                    _context.next = 21;
                    return (0, _effects.call)(fetch, subfolderPrefix + '/api/workflow/step', {
                        method: 'POST',
                        credentials: 'same-origin',
                        headers: {
                            'Accept': 'application/json',
                            'Authorization': anonymous === true && (!session.authenticationToken || !session.authenticationToken.token) ? null : session.authenticationToken.token,
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            control: {
                                direction: 'next',
                                entity: entity
                            },
                            returns: returns
                        })
                    });

                case 21:
                    stepResponse = _context.sent;
                    _context.next = 24;
                    return (0, _effects.call)([stepResponse, 'json']);

                case 24:
                    stepResult = _context.sent;

                    if (stepResult.operation.status) {
                        _context.next = 29;
                        break;
                    }

                    _context.next = 28;
                    return (0, _effects.put)((0, _metrixCommon.reduceLoading)(false));

                case 28:
                    return _context.abrupt('return');

                case 29:
                    if (!actionCode) {
                        _context.next = 33;
                        break;
                    }

                    _context.next = 32;
                    return (0, _effects.call)(fetch, subfolderPrefix + '/api/workflowpolicyaction/action/' + actionCode + '/' + guid, {
                        method: 'POST',
                        credentials: 'same-origin',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        }
                    });

                case 32:
                    response = _context.sent;

                case 33:

                    if (!actionCode || response && response.status === 202) {
                        window.location.href = target;
                    }
                    _context.next = 39;
                    break;

                case 36:
                    _context.prev = 36;
                    _context.t0 = _context['catch'](2);

                    console.error('An error occurred:', _context.t0);

                case 39:
                    _context.prev = 39;
                    _context.next = 42;
                    return (0, _effects.put)((0, _metrixCommon.reduceLoading)(false));

                case 42:
                    return _context.finish(39);

                case 43:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this, [[2, 36, 39, 43]]);
}